import styled from 'styled-components';
import { rem } from 'polished';

interface IStyledHome {
  theme: any;
}

export const StyledHome = styled.div<IStyledHome>`
  height: auto;

  /* Section */
  .section {
    max-width: ${rem(`1200px`)};
    width: 100%;
    padding-top: ${rem(`60px`)};
    margin-bottom: ${rem(`136px`)};
    &:last-child {
      margin-bottom: 0;
    }
  }
  .main-title {
    font-size: 3rem;
    line-height: 3.5rem;
    margin-bottom: 0;
    ${(props) => props.theme.breakpoints.phone`
      font-size: 4rem;
    `}
    ${(props) => props.theme.breakpoints.desktop`
      font-size: 4rem;
        line-height: 4rem;
    `}
  }

  .three-by-two-fifth {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-gap: ${rem(`36px`)};
  }

  /* projects-slider */
  .project-slider-header {
    margin-bottom: ${rem(`20px`)};
  }

  /* About */
  .about {
    &__members {
      grid-column: 1/5;
      grid-row: 1;
    }
    &__content {
      grid-column: 5/14;
      grid-row: 1;
      p {
        margin-bottom: ${rem(`12px`)};
      }
    }
  }
  .about__sub-header {
    margin-bottom: ${rem(`24px`)};
  }
  .mobile-about__content {
    margin-bottom: ${rem(`28px`)};
  }
  .team-members {
    display: grid;
    align-items: center;
    justify-content: flex-start;
    grid-gap: ${rem(`18px`)} ${rem(`24px`)};
    grid-template-columns: repeat(1, 1fr);
    ${({ theme }) => theme.breakpoints.phablet`
      grid-template-columns: repeat(2, 1fr);
    `}
    ${({ theme }) => theme.breakpoints.tablet`
      grid-template-columns: repeat(3, 1fr);
    `}
    ${({ theme }) => theme.breakpoints.desktop`
      grid-template-columns: repeat(1, 1fr);
    `}
  }
  .section-header {
    margin-bottom: ${rem(`24px`)};
    &--extra {
      margin-bottom: ${rem(`36px`)};
    }
  }
  .section-subtitle {
    margin-bottom: ${rem(`6px`)};
    ${({ theme }) => theme.breakpoints.desktop`
      margin-bottom: ${rem(`24px`)};
    `}
    &--spacer {
      margin-bottom: ${rem(`24px`)};
      ${({ theme }) => theme.breakpoints.tablet`
        margin-bottom: ${rem(`18px`)};
      `}
      ${({ theme }) => theme.breakpoints.desktop`
        margin-bottom: ${rem(`24px`)};
      `}
    }
  }
  .services-title {
    margin-bottom: ${rem(`24px`)};
  }
  .cta {
    margin-bottom: ${rem(`24px`)};
  }

  /* Blog */
  .blog-button {
    display: flex;
    justify-content: center;
    margin-top: ${rem(`32px`)};
  }
  .blog-slider-header {
    margin-bottom: ${rem(`16px`)};
  }

  .mobile-content-welcome {
    width: 100%;
    ${(props) => props.theme.breakpoints.phablet`
      width: 75%;
    `}
    ${(props) => props.theme.breakpoints.tablet`
      width: 66%;
    `}
    ${(props) => props.theme.breakpoints.desktop`
      width: 75%;
    `}
  }

  /* Contact */
  .side-by-side {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: ${rem(`24px`)};
    ${(props) => props.theme.breakpoints.phablet`
      grid-template-columns: repeat(2, 1fr);
      grid-gap: ${rem(`48px`)};
    `}
  }
  .contact__content {
    padding-right: 0;
    text-align: left;
    ${(props) => props.theme.breakpoints.desktop`
      padding-right: ${rem(`32px`)};
    `}
  }
  .contact__body-before {
    margin-bottom: ${rem(`12px`)};
  }
  .contact-list {
    margin-bottom: ${rem(`12px`)};
  }

  /* Mobile */
  .mobile-content-welcome,
  .mobile-content-services,
  .mobile-content-banner,
  .mobile-content-processes,
  .mobile-content-projects,
  .mobile-content-technologies,
  .mobile-content-cta,
  .mobile-content-social,
  .mobile-content-contact,
  .mobile-content-members,
  .mobile-content-blog {
    padding: 0 ${rem(`16px`)};
  }

  .mobile-content-header {
    padding: 0 ${rem(`16px`)};
  }
  .mobile-content-cta {
    .content {
      margin-bottom: ${rem(`24px`)};
    }
  }
  .mobile-content-services {
    margin-bottom: ${rem(`48px`)};
    ${({ theme }) => theme.breakpoints.phone`
      margin-bottom: ${rem(`24px`)};
    `}
    ${({ theme }) => theme.breakpoints.tablet`
      margin-bottom: ${rem(`48px`)};
    `}
  }
  .mobile-content-contact__container {
    display: flex;
    text-align: center;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: ${rem(`16px`)};
    background-color: ${({ theme }) => theme.colors.blue_1_65};
    border-radius: ${rem(`12px`)};
    ${({ theme }) => theme.breakpoints.phablet`
      padding: ${rem(`24px`)} ${rem(`16px`)};
    `}
  }
`;
